<a [routerLink]="to" style="height: 100%;">
    <mat-card class="dashboard-option">
        <img [src]="src" alt="">
        <span>
    {{title}}
  </span>
    </mat-card>
</a>
